// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"PhotoContainer_imageWrapper__2jfPW","imageContainer":"PhotoContainer_imageContainer__2CgBu","image":"PhotoContainer_image__3S-TK"};